import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Container } from '@mui/material';

import RegisterForm from '@layouts/RegisterForm';

const Register = memo(() => {
    const { t } = useTranslation();
    let navigate = useNavigate();

    const [success, setSuccess] = useState(false);

    return (
        success === true ?
            <div className=' pos-relative min-h-100vh'>
                <div className='p-t-50' style={{ width: 100, maxWidth: '50%', margin: '0 auto' }}>
                    <img src='/logo-text-white.png' alt="logo" className='w-full' />
                </div>
                <div className="p-t-60 p-b-60 p-lr-24 txt-center max-w-full" style={{width:380, margin:'0 auto'}}>
                    <div className='txt-center cl-white'>
                        <p className='fs-25 p-b-10'><b>{t('user.registerSuccess')}</b></p>
                        <p className='fs-16'>{t('user.registerSuccessSubline')}</p>
                    </div>
                    <div className='p-t-30 w-full'>
                        <Button variant="contained" onClick={() => navigate("/login")} fullWidth >{t('general.signIn')}</Button>
                    </div>
                </div>
            </div>
            :
            <div className=' pos-relative min-h-100vh' >
                <div className='p-t-50' style={{ width: 100, maxWidth: '50%', margin: '0 auto' }}>
                    <img src='/logo-text-white.png' alt="logo" className='w-full' />
                </div>
                <Container className='p-b-24'>
                    <p className='p-t-35 fs-21 cl-white' style={{ fontWeight: 'bold' }}>
                        {t('title.register')}
                    </p>
                    <RegisterForm setSuccess={setSuccess} />
                </Container>
            </div>
    )
});

export default Register;